import {useRef} from "react";

import type {ResolvedContentPath} from "../types/types.ts";

import {arePathsEqual} from "./utils/resolved-content-path-utils.ts";

export default function useStableContentPath<
    T extends ResolvedContentPath | null | undefined,
>(contentPath: T): T {
    const mostRecentContentPathRef = useRef<T>(contentPath);

    const mostRecentContentPath = mostRecentContentPathRef.current;
    if (
        !contentPath ||
        !mostRecentContentPath ||
        !arePathsEqual(contentPath, mostRecentContentPath)
    ) {
        mostRecentContentPathRef.current = contentPath;
    }

    return mostRecentContentPathRef.current;
}
